<app-header></app-header>
<div class="container">
    <router-outlet></router-outlet>
</div>
<footer>
    <div style="height: 60px">
        <!--placeholder-->
    </div>
</footer>
